import React from "react";

import { DropEvent, FileRejection, useDropzone } from "react-dropzone";

import { FileFilled } from "@ant-design/icons";

import { bytesToMB } from "@/utils/helpers";

import styles from "./FileUploadDropZone.module.scss";

interface FileUploadDropZoneProps {
  onDrop: (acceptedFiles: File[]) => void;
  onDropRejected: (rejectedFiles: FileRejection[], event: DropEvent) => void;
  maxSize?: number;
  error?: string;
  fileName?: string;
}

const FileUploadDropZone = ({
  onDrop,
  onDropRejected,
  maxSize = 0,
  error,
  fileName,
  ...rest
}: FileUploadDropZoneProps) => {
  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    onDropRejected,
    accept: {
      "application/vnd.android.package-archive": [".apk"],
    },
    maxFiles: 1,
    maxSize: maxSize,
    ...rest,
  });

  const classes = error
    ? `${styles.container} ${styles.error}`
    : styles.container;

  return (
    <div className={classes} {...getRootProps()}>
      <input {...getInputProps()} />
      <FileFilled style={{ fontSize: 40 }} />
      <div className={styles.textWrapper}>
        {fileName === undefined ? (
          <>
            <span>Click or drag and drop to upload files</span>
            <span>Maximum file size is {bytesToMB(maxSize)}MB.</span>
          </>
        ) : (
          <span>{fileName}</span>
        )}
      </div>
    </div>
  );
};

export default FileUploadDropZone;
